module.exports = __webpack_public_path__ + "static/media/watch-wallet.7659b37b.svg";